<div class="flex items-center w-full mb-4">
	<search tuiSearch class="w-full">
		<fieldset>
			<tui-textfield
				iconStart="@tui.search"
				[tuiTextfieldCleaner]="false"
			>
				<input
					tuiAutoFocus
					tuiInput
					[placeholder]="'action.search' | transloco"
					[ngModel]="search$ | async"
					(ngModelChange)="search$.next($event)"
				/>

				@if (search$ | async; as search) {
					<button
						tuiCleaner
						tuiIconButton
						appearance="ghost"
						(click)="search$.next('')"
					>
						<tui-icon size="xs" icon="@tui.x" />
					</button>
				}
			</tui-textfield>
		</fieldset>
	</search>
</div>

<tui-tabs [(activeItemIndex)]="tabIndex">
	@for (tab of tabs; track tab) {
		<button tuiTab type="button">
			{{ tab.label | transloco }}
		</button>
	}
</tui-tabs>

<!-- negative margin to offset the included padding for the modal -->
<div #scroller class="h-[400px] mx-[-1.75rem] pb-7 overflow-auto flex flex-col">
	@switch (activeTab.key) {
		@case ('shared') {
			@if (sharedWith$ | async; as data) {
				@if (loadingSharedWith()) {
					@for (item of [].constructor(3); track $index) {
						<mar-algolia-user-row
							[skeleton]="true"
							[class.border-t-2]="!$first"
							[class.border-gray-200]="!$first"
						/>
					}
				} @else if (data.length) {
					@for (item of data; track item.id) {
						<mar-algolia-user-row
							[name]="item.displayName"
							[email]="item.email"
							[class.border-t-2]="!$first"
							[class.border-gray-200]="!$first"
						>
							@if (item.id === analysis().createdBy.id) {
								<p class="font-semibold px-4 text-sm">
									{{ 'user.owner' | transloco }}
								</p>
							} @else {
								<button
									size="s"
									tuiButton
									appearance="negative"
									(click)="onRemove(item)"
									[loading]="processing().has(item.id)"
								>
									{{ 'action.remove' | transloco }}
								</button>
							}
						</mar-algolia-user-row>
					}
				} @else {
					<ng-container
						*ngTemplateOutlet="
							noResults;
							context: {
								text: 'analyses.dialog.share-analysis.shared-with.placeholder',
							}
						"
					/>
				}
			}
		}

		@case ('all') {
			@if (loading$ | async) {
				@for (item of [].constructor(3); track $index) {
					<mar-algolia-user-row
						[skeleton]="true"
						[class.border-t-2]="!$first"
						[class.border-gray-200]="!$first"
					/>
				}
			} @else {
				<!-- @todo: enable when invite/sendgrid workflow is working  -->
				<!-- @if ((search$ | async)?.trim()?.toLowerCase(); as search) {
					@if (!emails.has(search) && (search | validEmail)) {
						<mar-algolia-user-row
							[email]="search"
							class="border-b-2 border-primary"
						>
							<button
								size="s"
								tuiButton
								appearance="outline"
								(click)="onInvite(search)"
							>
								{{ 'action.invite' | transloco }}
							</button>
						</mar-algolia-user-row>
					}
				} -->

				@if (paginatedObject; as data) {
					@if (data.items.length) {
						@for (item of data.items; track item.objectID) {
							<mar-algolia-user-row
								[name]="item.data.displayName"
								[email]="item.data.email"
								[class.border-t-2]="!$first"
								[class.border-gray-200]="!$first"
							>
								@if (
									item.objectID === analysis().createdBy.id
								) {
									<p class="font-semibold px-4 text-sm">
										{{ 'user.owner' | transloco }}
									</p>
								} @else if (
									!sharedWithSet.has(item.data.objectID)
								) {
									<button
										size="s"
										tuiButton
										appearance="outline"
										[loading]="
											processing().has(item.objectID)
										"
										(click)="onShare(item.data)"
									>
										{{ 'action.share' | transloco }}
									</button>
								}
							</mar-algolia-user-row>
						}
					} @else {
						<ng-container
							*ngTemplateOutlet="
								noResults;
								context: {
									text: 'analyses.dialog.share-analysis.all-users.placeholder',
								}
							"
						/>
					}
				}
			}
		}
	}
</div>

<ng-template #noResults let-text="text">
	<div tuiTablePlaceholder class="h-full flex-auto">
		@if (search$ | async; as search) {
			<h2>
				{{ 'generic.empty-search-placeholder' | transloco }}
			</h2>
		} @else {
			<h2>{{ text | transloco }}</h2>
		}
	</div>
</ng-template>
